module.exports = __webpack_public_path__ + "media/img/feature3-cec570c5b94a018b77eac7b4f318b7df.svg";